"use client";

import { useCallback, useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";

import { CHANNEL_TALK_PLUGIN_KEY } from "@/config/env";
import { cn } from "@/lib/utils";

export function FloatingActions() {
  const pathname = usePathname();
  const [scrollVisible, setScrollVisible] = useState(false);
  const [alert, setAlert] = useState(0);

  useEffect(() => {
    function handleScroll() {
      setScrollVisible(window.scrollY > 300);
    }
    window.addEventListener("scroll", handleScroll, { passive: true });

    if (CHANNEL_TALK_PLUGIN_KEY) {
      try {
        ChannelService.onBadgeChanged((_unread, alertCount) => {
          setAlert(alertCount);
        });
      } catch {
        // SDK not yet loaded — badge count will be unavailable
      }
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const openChat = useCallback(() => {
    if (!CHANNEL_TALK_PLUGIN_KEY) return;
    ChannelService.showMessenger();
  }, []);

  // Keep bank fields and the final confirmation free from floating controls on small screens.
  if (pathname === "/mypage/points") return null;

  return (
    <>
      <button
        type="button"
        onClick={scrollToTop}
        className={cn(
          "fixed bottom-[92px] right-6 z-50",
          "h-14 w-14 rounded-full bg-black text-white shadow-lg",
          "hover:bg-neutral-600 transition duration-300 ease-in-out",
          "flex items-center justify-center",
          "active:scale-75",
          scrollVisible ? "opacity-100" : "opacity-0 pointer-events-none",
        )}
        aria-label="맨 위로"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 22V4m0 0l-7 7m7-7l7 7" />
        </svg>
      </button>

      {CHANNEL_TALK_PLUGIN_KEY && (
        <button
          type="button"
          onClick={openChat}
          className={cn(
            "fixed bottom-6 right-6 z-50",
            "h-14 w-14 rounded-full bg-black text-white shadow-lg",
            "hover:bg-neutral-600 transition duration-300 ease-in-out",
            "flex items-center justify-center",
            "active:scale-75",
          )}
          aria-label="채팅 상담"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M12 2C6.48 2 2 5.92 2 10.66c0 2.81 1.65 5.31 4.22 6.89-.14 1.48-.68 3.05-1.6 4.45 2.37-.4 4.22-1.42 5.48-2.36.62.09 1.25.14 1.9.14 5.52 0 10-3.92 10-8.78S17.52 2 12 2z" />
          </svg>
          {alert > 0 && (
            <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold">
              {alert > 9 ? "9+" : alert}
            </span>
          )}
        </button>
      )}
    </>
  );
}
